import {useQuery} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useClient} from "../utils/hooks";

const useGetCountries = () => {
  const client = useClient("GENERAL");

  return useQuery<
    {
      name: string;
      code: string;
    }[],
    AxiosError<{status: boolean; message: string}>
  >({
    queryKey: ["countries"],
    queryFn: () => client("general/countries").then((data) => data.data),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
const useGetCategories = () => {
  const client = useClient("GENERAL");

  return useQuery<string[], AxiosError<{status: boolean; message: string}>>({
    queryKey: ["categories"],
    queryFn: () => client("general/categories").then((data) => data.data),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
const useGetCurrencies = () => {
  const client = useClient("GENERAL");

  return useQuery<string[], AxiosError<{status: boolean; message: string}>>({
    queryKey: ["currencies"],
    queryFn: () => client("general/currencies").then((data) => data.data),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};

interface SupportedCurrenciesResponse {
  status: boolean;
  message: string;
  data: {
    sourceCurrency: string;
    supportedCurrencies: string[];
  };
}

const useGetSupportedCurrencies = (sourceCurrency?: string) => {
  const client = useClient("GENERAL");
  return useQuery<string[], AxiosError<{status: boolean; message: string}>>({
    queryKey: ["supported-currencies", sourceCurrency],
    queryFn: () =>
      client(`currencies/supported?sourceCurrency=${sourceCurrency}`).then(
        (data) => data.data.supportedCurrencies
      ),
    enabled: !!sourceCurrency,
    staleTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
  });
};

export {useGetCountries, useGetCategories, useGetCurrencies, useGetSupportedCurrencies};
